'use strict';

(function() {
	angular.module('onboarding.internaladmin')
		.directive('cobAdminBrokerUsageReport', cobAdminBrokerUsageReport);

	cobAdminBrokerUsageReport.$inject = ['subjectObserverMessagesService', 'observerService', 'internalAdminService'];

	var subjectObserverMessagesService, observerService, internalAdminService;

	function cobAdminBrokerUsageReport(_subjectObserverMessagesService_, _observerService_, _internalAdminService_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		internalAdminService = _internalAdminService_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/internaladmin/cobAdminBrokerUsageReport.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			scope.ajaxIsRunning = false;
			scope.brokers = [];
			scope.sortReverse = false;
			scope.sortType = 'average';

			scope.sortClicked = sortClicked;
			getReport();
		}

		function getReport() {
			if (scope.ajaxIsRunning) {
				return;
			}

			scope.ajaxIsRunning = true;
			setTimeout(function() {
				observerService.sendMessageToSubject(scope,
					subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			},
			1);

			internalAdminService.getBrokerUsageReport()
				.then(function(response) {
					scope.brokers = response.data.brokers;
				})
				.finally(function() {
					scope.ajaxIsRunning = false;
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
				});

			return;
		}

		function sortClicked(sortType) {
			if (scope.sortType === sortType) {
				scope.sortReverse = !scope.sortReverse;

				return;
			} else {
				scope.sortType = sortType;
				scope.sortReverse = false;
			}
		}
	}
})();
